
var createReactClass = require('create-react-class');
import React from 'react';

const ChannelFilter = createReactClass({
  getInitialState: function() {
    return {
      filter: "Channel::AcademicChannel"
    }
  },

  componentWillMount: function() {
    if(this.props.selectedChannel.type) {
      this.setState({
        filter: this.props.selectedChannel.type
      })
    }
  },

  handleFilter: function(filter) {
    var self = this;

    if(self.state.filter == filter) { filter = null; }

    self.setState({filter: filter}, function() {
      self.props.onFilter(filter);
    });
  },

  render: function() {
    return (
      <p>
        <a
          id="academic-departments"
          style={ this.state.filter == 'Channel::AcademicChannel' ? {fontWeight: 'bold'} : {}}
          onClick={ this.handleFilter.bind(this, 'Channel::AcademicChannel') }>
          Academic
        </a>
        &nbsp;
        |
        &nbsp;
        <a
          style={ this.state.filter == 'Channel::CommercialChannel' ? {fontWeight: 'bold'} : {}}
          onClick={ this.handleFilter.bind(this, 'Channel::CommercialChannel') }>
          Commercial
        </a>
      </p>
    )
  }
});

export default ChannelFilter;
